import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6448dadb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mr-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex justify-between text-xs" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "flex flex-col items-end" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "relative mt-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pair-line absolute h-1/2 mx-9 border-b border-dashed border-gray-500" }, null, -1))
const _hoisted_11 = { class: "relative z-10 flex justify-between" }
const _hoisted_12 = { class: "relative my-1.5 mx-4" }
const _hoisted_13 = { class: "relative z-10" }
const _hoisted_14 = { class: "w-4 ml-4 flex items-center" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "w-10 mr-4 text-xs text-right text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_ctx.routes.length > 0)
    ? (_openBlock(), _createBlock(_component_BalCard, {
        key: 0,
        shadow: "none"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex text-gray-500 items-center cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1),
            (_ctx.visible)
              ? (_openBlock(), _createBlock(_component_BalIcon, {
                  key: 0,
                  name: "akar-icons:chevron-up",
                  size: "sm"
                }))
              : (_openBlock(), _createBlock(_component_BalIcon, {
                  key: 1,
                  name: "akar-icons:chevron-down",
                  size: "sm"
                }))
          ]),
          (_ctx.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.routes.length === 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      textContent: _toDisplayString(_ctx.$t('noData')),
                      class: "mt-5 text-sm text-gray-500"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.input.amount), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.input.symbol), 1)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.output.amount), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.output.symbol), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_BalAsset, {
                              address: _ctx.input.address,
                              size: 36
                            }, null, 8, ["address"]),
                            _createVNode(_component_BalAsset, {
                              address: _ctx.output.address,
                              size: 36
                            }, null, 8, ["address"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "flex justify-between",
                        style: _normalizeStyle({ margin: `8px ${12 + _ctx.routes.length}px` })
                      }, [
                        _createVNode(_component_BalIcon, {
                          name: "akar-icons:triangle",
                          size: "xxs",
                          filled: true,
                          class: "transform rotate-180 text-gray-500"
                        }),
                        _createVNode(_component_BalIcon, {
                          name: "akar-icons:triangle",
                          size: "xxs",
                          filled: true,
                          class: "text-gray-500"
                        })
                      ], 4),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            style: _normalizeStyle({
              height: `${18 + 70 * index}px`,
              width: `calc(100% - ${4 * (_ctx.routes.length - index - 1)}px + 1px)`,
              margin: `0 ${2 * (_ctx.routes.length - index - 1) - 1}px`,
            }),
                            class: "absolute border-l border-r border-b border-gray-500 rounded-b-md"
                          }, null, 4))
                        }), 128)),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: route.hops[0]?.pool?.address,
                              class: "mt-9 first:mt-0 flex justify-between"
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_BalIcon, {
                                  name: "akar-icons:triangle",
                                  size: "xxs",
                                  filled: true,
                                  class: "transform rotate-90 text-gray-500"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.hops, (hop) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: hop?.pool?.address,
                                    class: "ml-4 first:ml-0 flex bg-white hover:bg-gray-50 dark:bg-gray-900 dark:hover:bg-gray-800 border border-gray-100 hover:border-gray-300 dark:border-gray-600 dark:hover:border-gray-400 rounded-xl shadow transition-colors"
                                  }, [
                                    _createElementVNode("a", {
                                      class: "flex p-1.5",
                                      href: _ctx.getPoolLink(hop.pool.id),
                                      target: "_blank"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hop.pool.tokens, (token) => {
                                        return (_openBlock(), _createBlock(_component_BalAsset, {
                                          class: "ml-1.5 first:ml-0",
                                          key: token.address,
                                          address: token.address,
                                          size: 20
                                        }, null, 8, ["address"]))
                                      }), 128))
                                    ], 8, _hoisted_16)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatShare(route.share)), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}